(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller("PlatformRentalScheduleReportController", PlatformRentalScheduleReportController);

    PlatformRentalScheduleReportController.$inject = ["PlatformRentalService", "VirtualFairService"];

  function PlatformRentalScheduleReportController(PlatformRentalService, VirtualFairService) {

    var vm = this;
    vm.flag                    = false;
    vm.types                   = [{name:'All', id:-1},{name:'Confirmed', id:1},{name:'Pending', id:0}, {name : 'Attended', id : 2}];
    vm.typeSelected            = -1;
    vm.virtualFairSelected     = '';
    vm.scheduleReport          = scheduleReport;
    vm.getAllVirtualFair       = getAllVirtualFair;
    vm.virtualFair             = [];

    function active() {
        vm.getAllVirtualFair();
    }

    function scheduleReport() {
        vm.virtualFair = vm.virtualFairs.filter(item => item.id == vm.virtualFairSelected)[0];
        console.log(vm.virtualFair)
        let query = {};
        if(vm.typeSelected != -1) {
            query['type'] = vm.typeSelected;
        }
        if(vm.virtualFairSelected != -1) {
          query['event_id'] = vm.virtualFairSelected;
        }
        query['event_type'] = 'virtual_fair';
        query['has_networking_event'] = vm.virtualFair.has_networking_event;
        PlatformRentalService.scheduleReport(vm.virtualFairSelected, query).then(function(response) {
            vm.flag = true;
        }).catch(function(err) {
            // 
        });
    }

    function getAllVirtualFair() {
      if(!vm.virtualFairs) {
          VirtualFairService.getAll(vm.isPlatformRental).then(function(response) {
              vm.virtualFairs = response.data;
          }).catch(function(err) {
          });
      }
    }

    active();
  }
})();
